<template>
    <div id="hqmh">
        <headTop :id="id" @topback="topback"></headTop>
        <div class="banner" id="index">
            <img src="../../../static/images/qtbjt.png" alt="" style="width: 100%;">
        </div>
        <detailBread :breadName="'高校基金会管理系统'"></detailBread>
        <div class="container">
            <div class="page-title">
                高校基金会管理系统
            </div>
            <div class="page-content" style="text-align:left;width:1000px;margin:0 auto;">
                <p>高校教育基金会是以服务高校自身为目的，面向社会开展筹款与捐赠管理的非盈利机构。</p>
                <p>随着基金会捐赠项目和资金规模的几何增长，传统的人力手工模式已不能满足基金会项目管理工作的发展要求。所以通过信息化手段整合基金会项目管理工作流程，搭建一个面向多用户群体的基金会项目管理平台，是提升高校基金会管理工作水平的重要手段。</p>
                <p>昂克高校教育基金会管理系统完成了整合资源、分模块化管理，记录跟踪与捐赠人交往过程、项目管理、协同平台管理和基金会网站管理、解决基金会信息收集、管理和使用、基金分散与集中的问题、基金信息统计与分析、各环节信息汇总与查询的问题，极大地提高了基金会信息管理水平，为决策提供有效的信息依据，为资金筹措工作提供有力的信息基础保障。</p>
                <p style=" font-size: 18px; font-weight: bold; margin: 20px 0;">一、多平台整合 PC+Mobile</p>
                <p>PC端+微信公众号，拓宽基金会宣传渠道，增加基金会与外界互动，提升社会关系</p>
                <p style=" font-size: 18px; font-weight: bold; margin: 20px 0;">二、覆盖全节点的项目流程管理</p>
                <p>项目流程管理，从筹款到立项，再到项目执行和验收，全方位把控每个环节</p>
                <p style=" font-size: 18px; font-weight: bold; margin: 20px 0;">三、多渠道的捐赠系统，拓宽基金会筹款渠道</p>
                <p>门户网站的在线捐赠页面和微捐赠页面，提供了资金捐赠网页在线支付和手机扫码支付通道，微信公众号中的捐赠菜单，支持微信支付和支付宝支付，使得捐赠更加便捷，门户网站和公众号中会显示捐赠列表，提升校友们的荣誉感、责任感以及归属感，这也是高校文化建设的重要一环。</p>
            </div>
        </div>
    </div>
</template>
<script>
import headTop from '@/components/headTop'
import detailTop from '@/components/detailTop'
import detailBread from '@/components/detailBread'
export default {
    metaInfo: {
        title: '高校基金会管理系统', // set a title
        meta: [{             // set meta
            name: 'keyWords',
            content: '高校基金会管理系统'
        },
        {
            name: 'description',
            content: '高校基金会管理系统'
        }],
    },
    components:{
        detailTop,
        detailBread,
        headTop
    },
    data() {
        return {
            id:'3',
        }
    },
    methods: {
        topback(){
            this.$router.push({
                path:'/',
            })
        }
    },
    mounted() {
        $('html,body').animate({
            scrollTop: 0 + "px"
        }, {
            duration: 0,
            easing: "swing"
        });
        return false;
    },
    
}
</script>
<style scoped>
.page-content p {
    text-indent: 32px;
    font-size: 16px;
    line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/pages/old/gxjjhglxt.vue